<template>
  <LoadingElement v-if="isLoading" class="aspect-square w-full bg-transparent md:aspect-video" />
  <template v-else>
    <template v-for="crossSellings in crossSellingProducts" :key="crossSellings.id">
      <h2 class="mx-auto pb-4 text-3xl font-medium">{{ crossSellings.name }}</h2>

      <div class="mx-auto max-w-max 2xl:grid 2xl:grid-cols-2 2xl:gap-2">
        <template v-for="product in crossSellings.products" :key="product.id">
          <ProductCrossSellingCard
            :cross-selling-product="product"
            @close-cross-selling-modal="$emit('close-cross-selling-modal')"
          >
          </ProductCrossSellingCard>
          <template
            v-for="(subscription, index) in product.extensions?.subscription
              ?.intervalConfigurations"
            :key="subscription.id"
          >
            <ProductCrossSellingCard
              :cross-selling-product="product"
              :subscription-index="index"
              @close-cross-selling-modal="$emit('close-cross-selling-modal')"
            >
            </ProductCrossSellingCard>
          </template>
        </template>
      </div>
    </template>
  </template>
</template>

<script setup lang="ts">
import ProductCrossSellingCard from "~/templates/components/shop/product/ProductCrossSellingCard.vue";
import { useCrossSelling } from "~/composables/shop/useCrossSellings";
import LoadingElement from "~/templates/elements/LoadingElement.vue";
const emits = defineEmits(["close-cross-selling-modal"]);
const isLoading = ref(true);

const { crossSellingProducts, loadCrossSellingProducts } = await useCrossSelling();

onMounted(async () => {
  await loadCrossSellingProducts();
  isLoading.value = false;
});
</script>
